<template>
  <div>
    <footer class="layout-footer new">
        <div class="contents-inner">

            <div class="service">
                <h2 class="title logo-bg"></h2>
                <div id="language" class="custom-select-container" @focusout="selectStatus = false">
                    <button type="button" class="btn-custom-select" v-bind:class="{'is-selected' : selectStatus }" v-on:click="toggleSelectLang()">{{ $t('LANGUAGE') }}</button>
                    <div class="list-container">
                        <ul v-if="homepageInfo.availableLang" class="list-custom-select">
                            <li v-for="lang of homepageInfo.availableLang" v-bind:class="{'is-selected': $i18n.locale === lang.langCd}">
                                <button type="button" v-on:click="changeLang(lang.langCd)">{{lang.langNm}}</button>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>

            <div class="utils">
                <p class="policy">

                    <a :href="moveAgreement" style="cursor: pointer">{{ $t('FOOTER.POLICY.SERVICE_AGREEMENT') }}<!--서비스약관--></a>
                    <a :href="movePrivacy" style="cursor: pointer; font-weight: bold">{{ $t('FOOTER.POLICY.PRIVACY_POLICY') }}<!--개인정보취급방침--></a>
                    <a :href="moveThirdPartyServiceTerms" v-if="domain === 'opsnow.com'" style="cursor: pointer">{{ $t('FOOTER.POLICY.THIRD_PARTY_SERVICE_TERMS') }}<!--제 3자 솔루션 이용동의--></a>
                    <a href="" onclick="return false" data-trigger="popup-support" v-on:click="moveSupport()">{{ $t('FOOTER.TECHNICAL_SUPPORT') }}<!--기술 지원--></a>
                </p>

                <p class="company-info">
                    <span>{{ $t('FOOTER.COMPANY_INFO.CEO_NAME')}}</span>
                    <span>{{ $t('FOOTER.COMPANY_INFO.ADDRESS')}}</span>
                    <span>{{ $t('FOOTER.COMPANY_INFO.PHONE_NUMBER')}}</span>
                    <span>{{ $t('FOOTER.COMPANY_INFO.BUSINESS_LICENSE')}}</span>
                    <span>{{ $t('FOOTER.COMPANY_INFO.MAIL_ORDER_BUSINESS_REPORT')}}</span>
                </p>
                <small class="copyright" id="footer_copyright" v-html="homepageInfo.footer.copyRight"></small>
            </div>


        </div>
    </footer>
    <aside id="popup-footer-support" class="layout-popup popup-footer-support mfp-hide">
        <h2 class="layout-popup-title">
          {{ $t('FOOTER.TECHNICAL_SUPPORT') }}<!--기술 지원-->
        </h2>

        <div class="layout-popup-contents">
            <p class="layout-popup-message support">
              TEL<br>
              <label id="footer_tech_tel" v-html="homepageInfo.footer.techTelCntrCd + ' ' + homepageInfo.footer.techTelNo"></label><br>
              <br>
              E MAIL<br>
              <label id="footer_tech_email" v-html="homepageInfo.footer.techEmail"></label><br>
            </p>
        </div>
    </aside>
  </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: 'Footer',
        data: function() {
            return {
                selectStatus: false, // 다국어 선택창 펼침 상태 값
                domain: location.hostname.split('.').slice(1).join('.'),
            }
        },
        computed: {
            ...mapGetters({
                homepageInfo: 'common/homepageInfo',
                isNotWL: 'user/isNotWL'
            }),
            getLocale: function() {
                return this.$i18n.locale;
            },
            getSite: function () {
                return location.hostname;
            },
            moveAgreement() {
                const langCd = this.getLocale === 'ko' ? 'kr' : 'en'
                return this.domain === 'opsnow.com'
                    ? `https://www.opsnow.com/legal/${langCd}/terms-of-service`
                    : this.urls.portalUrl + '/agreement/service';
            },
            moveThirdPartyServiceTerms() {
                const langCd = this.getLocale === 'ko' ? 'ko' : 'en'
                return `https://www.opsnow.com/${langCd}/legal/third-party-service-terms`
            },
            movePrivacy() {
                const langCd = this.getLocale === 'ko' ? 'kr' : 'en'
                return this.domain === 'opsnow.com'
                    ? `https://www.opsnow.com/legal/${langCd}/privacy-policy`
                    : this.urls.portalUrl + '/agreement/privacy';
            },
        },
        watch: {
          homepageInfo: function(info) {
              !this.Common.isEmptyText(this.$cookies.get(this.constants.LangCode))
                  ? this.changeLang(this.$cookies.get(this.constants.LangCode))
                  : !this.Common.isEmptyText(info.availableLang) ? this.changeLang(info.availableLang) : this.constants.ENGLISH
          }
        },
        mounted(){
            if (this.isNotWL) this.showOpsBot();
        },
        methods: {
            // 언어 변경
            changeLang(locale) {
                this.$i18n.locale = locale;
                this.$cookies.set(this.constants.LangCode, locale, "1y" , '/', typeof(this.$store.state.sub_domain) !== this.constants.UNDEFINED ? this.$store.state.sub_domain : '')
                if(this.isNotWL) this.showOpsBot();
            },
            // 다국어 선택박스 상태 코드 변경 (펼침 <=> 닫힘)
            toggleSelectLang: function() {
                this.selectStatus = !this.selectStatus;
            },
            moveSupport: function() {
                const domain = location.hostname.split('.').slice(1).join('.')
                if (domain === 'opsnow.com' || domain === 'opsnow360.com' || domain === '.sec-alertnow.com') {
                    window.open(this.urls.supportUrl);
                } else {
                    this.Common.viewPopup('popup-footer-support');
                }
            },
            showOpsBot() { // 상담서비스 호출

                if (location.host.indexOf('opsnow.cn') > -1) { // 차이나 제외
                    return;
                }
                var js, omj = document.getElementsByTagName('script')[0];
                if (document.getElementById('opsbot-js')) {
                    return;
                }
                js = document.createElement('script');
                js.id = 'opsbot-js';
                js.src = 'https://bb8-server-prod.prd.helpnow.ai/api/scripts/opsbot.min.js';
                omj.parentNode.insertBefore(js, omj);
            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/common/layout/fnb/fnb.vue